/**
 * 产品权益常量
 */

define('constant/appmng/services.constant',[], function () {
    return {
        regexp: {
            packageName: '^[a-zA-Z][a-zA-Z0-9_]*(\\.[a-zA-Z0-9_]+)+$',
            oauthCertFingerprint: '^([0-9A-F]{64}|([0-9A-F]{2}:){31}[0-9A-F]{2})$',
            oauthCertFingerprintForRpk: '^[A-Fa-f0-9]{64}$',
            oauthRedirectUri: '^((https|http)+://)((?![\\s|@]).)*$',
            IMEI: '^[A-Za-z0-9]{14,16}$',
            IMEIS: '^([A-Za-z0-9]{14,16})(,[A-Za-z0-9]{14,16})*$',
            notifyNumber: '^\d{1,3}$',
            token: '^([A-Za-z0-9]{32})(,[A-Za-z0-9]{32})*$',
            wallpaperVersion: '^[1-9][0-9]{0,4}$',
            secureUrl: '^([^@]?[^\*&^@]*[^@]?)$',
            webAppUrl: '^((https|http)+://)((?![\\s|@]).)*$',
            fontDynamicName: '^([a-zA-Z0-9-\u4e00-\u9fa5])*$',
            bundleId:'^([\-A-Za-z0-9._])*$'
        }
    };
});

